import React from "react";
import { ColDef } from "ag-grid-community";
import { Box, Flex } from "@mantine/core";
import { VSpace } from "../../../../components";
import { AgGridReact } from "ag-grid-react";
import { IRIEDeviceCompare } from "./nrhRoomValTypes";

const RIESingleRoomValidationTable: React.FC<{ devices: IRIEDeviceCompare[] }> = ({ devices }) => {
  const columns: ColDef<any>[] = [
    {
      field: "compCode",
      headerName: "CompCode",
    },
    {
      field: "typeName",
      headerName: "Beskrivelse",
      width: 600,
    },
    {
      field: "countInStandard",
      headerName: "Antall i standardroom",
    },
    {
      field: "countInInstance",
      headerName: "Antall i modell (rom)",
      cellRenderer: (params) => {
        return (
          <span>
            {params.data.countInStandard !== params.value && (
              <i className="fa fa-exclamation-triangle fa-fw icon-warning" />
            )}
            {params.data.countInStandard === params.value && <i className="fa fa-check fa-fw icon-success" />}
            {params.value}
          </span>
        );
      },
    },
  ];

  return (
    <Flex h="100%" w="100%">
      <Box className="border ag-theme-alpine" h="100%" p="xs" style={{ overflow: "auto" }} w="100%">
        <VSpace />
        <AgGridReact rowData={devices} columnDefs={columns} masterDetail={true} />
      </Box>
    </Flex>
  );
};

export default RIESingleRoomValidationTable;
